import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { DerivePlainObject } from '../plainObjects/derive.plainObject';
import { MatchFunctionUtil } from '../utils/matchFunction.util';
import { SchemaUtil } from '../utils/schema.util';
import { ExpressionColumnPlainObject } from '../plainObjects/expressionColumn.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class DeriveVisitor extends BaseTransformationVisitor {
    private get _deriveTransformation(): DerivePlainObject {
        return this.transformation as DerivePlainObject;
    }

    public visitAssignment(assignment: any): ExpressionColumnPlainObject {
        const derivedColumn = new ExpressionColumnPlainObject();
        derivedColumn.name = SchemaUtil.getColumnName(assignment.columnIdentifier());
        derivedColumn.expression = this._getText(assignment.expression());
        this._deriveTransformation.columns.push(derivedColumn);
        return derivedColumn;
    }

    public visitTransientAssignment(assignment: any): void {
        const visitAssignment = this.visitAssignment(assignment);
        visitAssignment.transient = true;
    }

    public visitMetaFunctionExpr(context: any): void {
        MatchFunctionUtil.addColumnPatternColumns(this._deriveTransformation, this._tokenStream, context);
    }
}
